
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/the-new-turing-omnibus",
      function () {
        return require("private-next-pages/books/the-new-turing-omnibus.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/the-new-turing-omnibus"])
      });
    }
  